<template>
    <form method="POST" :action="route">
        <input type="hidden" name="_token" :value="token">
            
            <table class="myfotable">
                <thead style="background-color: rgba(38, 42, 62, .05);">
                    <tr>
                        <th scope="col" style="width: 15%;">Secteur</th>
                        <th scope="col" style="width: 20%;">Nom</th>
                        <th scope="col" style="width: 10%;">Code ISIN</th>
                        <th scope="col" style="width: 8%;">Classe d'actifs</th>
                        <th scope="col" style="width: 10%;">Secteur</th>
                        <th scope="col" style="width: 7%;">Versement (%)</th>
                        <th scope="col" style="width: 10%;">Fréquence</th>
                        <th scope="col" style="width: 7%;">Performance</th>
                        <th scope="col" style="width: 3%;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(position, index) in pos" :key="index">
                        <input type="hidden"
                            :name="'form[' + index + '][id]'"
                            :value="position.id ">
                        <td style="width:15%;">
                            <select
                                class="form-control-2"
                                style="font-size:11px;"
                                v-model="position.sector"
                                @change="onSectorChange(position)"
                                    :disabled="position.id != null">
                                <option value="" disabled>Nom</option>
                                <option v-for="sector in sectors" :key="sector" :value="sector" >{{ sector }} </option>
                            </select>

                            <input type="hidden"
                                :name="'form[' + index + '][security_id]'"
                                :value="position.security.id ">
                        </td>
                        <td style="width:20%;">
                        <select
                                class="form-control-2"
                                style="font-size:11px;"
                                v-model="position.security"
                                :disabled="position.id != null">
                                <option value="" disabled>Nom</option>
                                <option v-for="secu in filteredSecurities(position.sector)" :key="secu.id" :value="secu">{{ secu.name }}</option>
                            </select>

                            <input type="hidden"
                                style="font-size:11px;"
                                :name="'form[' + index + '][security_id]'"
                                :value="position.security.id ">
                        </td>
                        <td style="width:10%;">
                            {{ position.security.isin }}
                        </td>
                        <td style="width:8%; text-transform: capitalize;">
                            {{ position.security.asset_class.name }}
                        </td>
                        <td style="width:10%; text-transform: capitalize;">
                            {{ position.security.sector.name }}
                        </td>
                        <td style="width:7%;">
                            <input
                                type="number"
                                class="form-control-2"
                                step="1"
                                min="0"
                                max="100"
                                :name="'form[' + index + '][contribution]'"
                                v-model.number="position.contribution">
                        </td>
                        <td style="width:10%;">
                        <select
                            class="form-control-2"
                            style="font-size:11px;"
                            v-model="position.frequency"
                            :disabled="position.id != null">
                            <option value="" disabled>Nom</option>
                            <option v-for="freq in freqs" :key="freq.id" :value="freq">{{ freq.name_french }}</option>
                        </select>
                            <input type="hidden"
                            style="font-size:11px; text-transform: capitalize;"
                            :name="'form[' + index + '][frequency_id]'"
                            :value="position.frequency.id ">
                        </td>
                        <td style="width:7%;">
                        {{ position.performance }} %
                        </td>
                        <td style="width:3%;">
                        <button
                            style="font-size:20px!important; text-align:center; vertical-align:middle; color:red;"
                            v-if="!position.disabled"
                            type="button"
                            class="close"
                            aria-label="Close"
                            v-on:click="pos.splice(pos.indexOf(position), 1)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </td>
                    </tr>
                </tbody>
            </table>
            
        <div class="row text-center justify-content-center my-4">
            <button type="button" class="btn-myfo-blue mr-2" v-on:click="addRaw"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/></svg>Rajouter une position</button>
            <button type="submit" class="btn-myfo-blue triggerspinner"><svg width="1em" height="1em" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="mr-2" viewBox="0 0 89.9 89.9"><title>save-v2</title><path d="M8.7,5A3.76,3.76,0,0,0,5,8.7V82.1a3.7,3.7,0,0,0,1,2.6l9.1,9.1a3.81,3.81,0,0,0,2.6,1.1H91.1a3.8,3.8,0,0,0,3.8-3.8V8.7A3.78,3.78,0,0,0,91.1,5ZM74.8,87.6c0,2-1.2,3.5-2.8,3.5H28.1c-1.7,0-2.9-1.5-2.9-3.5V61.8c0-1.9,1.2-3.7,2.9-3.7H72c1.7,0,2.8,1.8,2.8,3.7Zm3.7-48.2a3.69,3.69,0,0,1-3.7,3.7H25.2a3.83,3.83,0,0,1-3.7-3.7V15.5a3.69,3.69,0,0,1,3.7-3.7H74.8a3.76,3.76,0,0,1,3.7,3.7ZM42.1,82.9V66.5H33V83h9.1Z" transform="translate(-5 -5)"/></svg>Enregistrer</button>
        </div>

    </form>
</template>

<script>
    export default {
        props: [
            'positions',
            'securities',
            'frequencies',
            'token',
            'route',
        ],

        data() {
            return {
                secus:[],
                freqs: [],
                pos: [],
                sectors: [],
            }
        },

        mounted() {

            this.securities.forEach(security =>
            {
                this.secus.push(security)
                console.log(security.id)
            });

            this.secus.forEach(security => {
                if (!this.sectors.find(element => element == security.sector.name_french))
                {
                    this.sectors.push(security.sector.name_french);
                }
            });
            this.sectors = this.sectors.sort();

            this.frequencies.forEach(frequency =>
            {
                this.freqs.push(frequency)
            });

            this.positions.forEach(position =>
            {
                this.pos.push(
                {
                    id: position.id,
                    security: this.secus.find(element => element.id == position.security.id),
                    name: position.security.name,
                    isin: position.security.isin,
                    asset_class: position.security.asset_class.name_french,
                    sector: position.security.sector.name_french,
                    contribution: Math.round(position.contribution_weight*100,3),
                    frequency: this.freqs.find(element => element.id == position.dollar_cost_frequency.id),
                    performance: position.performance,
                });
            });

        },

        methods: {

            filteredSecurities(sector){
                return this.secus.filter(s => s.sector.name_french === sector);
            },

            onSectorChange(position){
                position.security = this.secus.filter(s => s.sector.name_french === position.sector)[0];
            },

            addRaw(){
                this.pos.push(
                {
                    id: null,
                    security: this.secus[0],
                    contribution: 0,
                    frequency: this.freqs[0],
                    performance: 0,
                    sector:this.sectors[0],
                });
                this.onSectorChange(this.pos[this.pos.length - 1]);

        }
    }
}

</script>